import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { StartupService } from '../common/services/startup.service';
import { constants } from '../configs/config-internal-constants'


interface Scripts {
    name: string;
    src: string;
}

interface ScriptInfo {
    loaded: boolean;
    src: string;
}

@Injectable()
export class EventTrackerSnippetScriptService {

    private scripts: Record<string, ScriptInfo> = {};
    scriptStore: Scripts[] = [];

    constructor(@Inject(DOCUMENT) private readonly document,private readonly startup: StartupService
       ) {
        this.scriptStore = [
            { name: 'eventsScript', src: this.prepareEventsUrl() }
        ];
        this.scriptStore.forEach((script: Scripts) => {
            this.scripts[script.name] = {
              loaded: false,
              src: script.src,
            };
        });
    }

 
    public initialize() {
        return this.loadHeader('eventsScript');
    }
 
    prepareEventsUrl() {
        const i = window.location.protocol;
       
        return ((i === "https:") ? "https:" : "http:") + this.startup.eventTrackerURL;
    }

    // Below function will set the customer id and updated page title to WUP call
    wupSetContextAndSessionId(pageTitle){
    try {
        window['cdApi'].setCustomerSessionId(sessionStorage.getItem('eventTrackSessionId'));
        window['cdApi'].changeContext(pageTitle);
      }
      catch (e) {
      // must not happen
    }
 }
 
     // Below function will set the page title to WUP call
    wupSetPageContext(pageTitle){
    try {
        window['cdApi'].changeContext(pageTitle);
      }
      catch (e) {
      // must not happen
    }
  }

    public loadHeader(name) {
        return new Promise((resolve, reject) => {
            // resolve if already loaded
            if (this.scripts[name].loaded) {
                resolve({ script: name, loaded: true, status: 'Already Loaded' });
            }
            else {
                // load script
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.async = true;
                const url = "https:" + this.startup.eventTrackerURL; 
                script.src = url;

                script.onload = () => {
                    this.wupSetContextAndSessionId(constants.EVENT_TRACKER.PAGE_TITLE);
                };
                script.onerror = () => resolve({ script: name, loaded: false, status: 'Loaded' });
                document.getElementsByTagName('head')[0].appendChild(script);
            }
        });
    }

   }